module.exports = __webpack_public_path__ + "img/con_item1_bgc.3a78e8bc.png";